// Each reel starts downloading only once it's on screen, plays muted while visible and pauses when
// scrolled away, so only the few videos in view are ever streaming. The sound button (when there is
// one) unmutes one reel at a time. Used by the homepage video gallery and the product page videos.
if (!customElements.get('tt-reel')) {
  customElements.define(
    'tt-reel',
    class TTReel extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.tt-reel__video');
        this.soundButton = this.querySelector('.tt-reel__sound');
        if (!this.video) return;

        // Reduced motion or data saver: show the first frame and wait for a tap instead of autoplaying
        this.autoplay =
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
          !(navigator.connection && navigator.connection.saveData);

        this.observer = new IntersectionObserver(([entry]) => this.onVisibilityChange(entry.isIntersecting), {
          threshold: 0.5,
        });
        this.observer.observe(this);

        if (this.soundButton) {
          this.soundButton.addEventListener('click', () => this.toggleSound());
          this.video.addEventListener('click', () => this.toggleSound());
        }

        // The card's shape comes from Liquid when it can (picked files); correct it from the file itself otherwise
        this.video.addEventListener('loadedmetadata', () => {
          const { videoWidth, videoHeight } = this.video;
          if (videoWidth && videoHeight) this.style.setProperty('--tt-ratio', videoWidth / videoHeight);
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      load() {
        if (this.video.hasAttribute('src')) return;
        this.video.preload = this.autoplay ? 'auto' : 'metadata';
        this.video.src = this.autoplay ? this.video.dataset.src : `${this.video.dataset.src}#t=0.1`;
      }

      onVisibilityChange(visible) {
        if (visible) {
          this.load();
          if (this.autoplay) this.play();
        } else {
          this.setMuted(true);
          this.video.pause();
        }
      }

      play() {
        // Autoplay can still be refused (e.g. iOS Low Power Mode); the reel then just shows its first frame
        const playing = this.video.play();
        if (playing) playing.catch(() => {});
      }

      toggleSound() {
        const unmute = this.video.muted;
        if (unmute) {
          document.querySelectorAll('tt-reel').forEach((reel) => reel !== this && reel.setMuted(true));
          this.load();
          this.play();
        } else if (!this.autoplay) {
          this.video.pause();
        }
        this.setMuted(!unmute);
      }

      setMuted(muted) {
        if (!this.video) return;
        this.video.muted = muted;
        if (this.soundButton) this.soundButton.setAttribute('aria-pressed', !muted);
      }
    }
  );
}
